import React, { Suspense, lazy, useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import RModal from 'react-modal'
import axios from 'axios'
import './index.scss'
// Initialize languages
import './locales/i18n'
import { getCapBackendUrl } from './backend-config'
const RootApp = lazy(() => import('./root-app'))

RModal.setAppElement('#root')
const Root = () => {
  const [appConfig, setAppConfig] = useState(false)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    const state = params.get('state')

    // this code is written because for SSO login, it will send the code to the opener window 
    if (code && window.opener) {
      window.opener.postMessage({ type: 'SSO_CODE', code, state }, window.opener.origin)
      window.close()
    }
  }, [])
  useEffect(() => {
    const fetchData = async () => {
      const backendUrl = getCapBackendUrl()
      const config = await axios.get(`${backendUrl}/api/v1/aen-frontend-app-config`)
      setAppConfig(true)
      sessionStorage.setItem('app-config', config.data.appConfig)
      sessionStorage.setItem('app-other-config', config.data.appOtherConfig)
    }
    fetchData()
  }, [])
  return (
    <>{appConfig &&
    <Suspense fallback={<></>}>
      <RootApp />
    </Suspense>
    }
    </>
  )
}

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<Root />)
